<template>

    <form ref="instituicaoensinousuario-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-12">
                <label for="escolaId">Escola CNA</label>
                <select v-select="{ dataitem: 'Escola', default: 'Selecione', filters: { AttributeBehavior: 'EscolaBoxParametroCNANaEscola'} }" v-model="model.escolaId" class="form-control" name="escolaId" required></select>
            </div>
            <div class="form-group col-md-12">
                <label for="instituicaoEnsinoId">Instituição de Ensino</label>
                <select v-select="{ dataitem: 'InstituicaoEnsino', default: 'Selecione' }" v-model="model.instituicaoEnsinoId" class="form-control" name="instituicaoEnsinoId" required></select>
            </div>
            <div class="form-group col-md-12">
                <label for="email">E-mail para acesso</label>
                <input type="email" class="form-control" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" name="Email"  placeholder="Endereço de E-mail" v-model="model.email" required />
            </div>
            <div class="form-group col-md-12">
                <label for="senha">Senha</label>
                <input type="password" class="form-control" name="senha" placeholder="Senha" v-model="model.senha" required />
            </div>
            <div class="form-group col-md-12">
                <div class="clearfix">&nbsp;</div>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ativo" class="custom-control-input" v-model="model.ativo">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Ativo?</span>
                </label>
            </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensinousuario-form-create",
        mixins: [base],
        data: () => ({

            model: {},

            form: "instituicaoensinousuario-form-create",
            
            resources: {
                create: 'instituicaoensinousuario',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                new Api("InstituicaoEnsinoUsuario/SalvarInstituicaoEnsinoUsuario").post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

